/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Event_GroupInputs */

const en_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Group`)
};

const fr_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groupe d'événements`)
};

const de_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppe`)
};

const it_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo eventi`)
};

const ru_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий`)
};

const es_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

const zh_cn2_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件组`)
};

const ja_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ`)
};

const hi_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह`)
};

const pt_pt2_offline_sync_event_group = /** @type {(inputs: Offline_Sync_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Event Group" |
*
* @param {Offline_Sync_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_event_group = /** @type {((inputs?: Offline_Sync_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_offline_sync_event_group(inputs)
	if (locale === "de") return de_offline_sync_event_group(inputs)
	if (locale === "it") return it_offline_sync_event_group(inputs)
	if (locale === "ru") return ru_offline_sync_event_group(inputs)
	if (locale === "es") return es_offline_sync_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_offline_sync_event_group(inputs)
	if (locale === "ja") return ja_offline_sync_event_group(inputs)
	if (locale === "hi") return hi_offline_sync_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_sync_event_group(inputs)
	return en_offline_sync_event_group(inputs)
});